<div
  class="policy-item"
  *ngIf="showCard"
>
  <ion-button
      fill="clear"
      class="policies-toggle-btn d-flex ion-justify-content-between pad6"
      (click)="togglePrivacyPolicy()"
    >
      <div class="policies-toggle-content">
        <ion-text class="fs-3 font700 ion-text-left blue-text-color">{{
          "esim.privacy_policy.title" | translate
        }}</ion-text>
        <ion-icon
          [name]="
            expanded ? 'chevron-up-outline' : 'chevron-down-outline'
          "
          class="policies-icon fs-5"
        ></ion-icon>
      </div>
  </ion-button>

  <div class="policies-content ion-padding" *ngIf="expanded">
      <div class="privacy-content">
        <b class="fs-4 font600 text-color">{{
          "privacy_policy.privacy_policy" | translate
        }}</b>

        <p class="fs-3 font600 text-color">
          {{ "esim.privacy_policy.section_1_title" | translate }}
        </p>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_1_content' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.privacy_policy.section_2_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_2_content' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.privacy_policy.section_3_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_3_content' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.privacy_policy.section_4_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_4_content' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.privacy_policy.section_5_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_5_content' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.privacy_policy.section_6_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_6_content' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.privacy_policy.section_7_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_7_content' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.privacy_policy.section_8_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_8_content' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.privacy_policy.section_9_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_9_content' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.privacy_policy.section_10_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_10_content' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.privacy_policy.section_11_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_11_content' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.privacy_policy.section_12_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_12_content' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.privacy_policy.section_13_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_13_content' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.privacy_policy.section_14_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_14_content' | translate"
        ></p>

        <b class="fs-3 font600 text-color">{{
          "esim.privacy_policy.section_15_title" | translate
        }}</b>
        <p
          class="fs-2 font400 text-color"
          [innerHTML]="'esim.privacy_policy.section_15_content' | translate"
        ></p>
      </div>
    </div>
</div>
